// DEPLOY: /var/www/woody.wtf/frontend/src/pages/EtfHoldingsPanel.js
// Feed ETF holdings to the existing MarketScanner controls and statistics.
import React, { useEffect, useState } from 'react';
import api from '../api';
import MarketScanner from './MarketScanner';

export default function EtfHoldingsPanel({ symbol, exchange, openChart }) {
  const [etf, setEtf] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!symbol) { setError('No ETF selected.'); return; }
    let active = true;
    setEtf(null);
    setError('');
    api.get('/etf/' + encodeURIComponent(symbol), { params: { exchange } })
      .then(r => { if (active) setEtf(r.data.etf); })
      .catch(() => { if (active) setError('Could not load ETF holdings.'); });
    return () => { active = false; };
  }, [symbol, exchange]);

  if (error) return <div style={{padding:'16px',color:'var(--text-muted)'}}>{error}</div>;
  if (!etf) return <div style={{padding:'16px',color:'var(--text-muted)'}}>Loading ETF holdings…</div>;

  return (
    <MarketScanner
      embedded
      holdings={etf.holdings || []}
      holdingsName={etf.name || symbol}
      onTickerClick={openChart}
    />
  );
}
